import { byKey as routesByKey, array as routesArray } from 'app/common/constants/routes.constants';
import { createBrowserHistory as createHistory } from 'history';
import { generatePath, matchPath } from 'react-router-dom';

const history = createHistory();

const generateTabUrl = (tabName, urlParams) => {
    let correspondingRoute = routesByKey[tabName];
    if (!correspondingRoute || !correspondingRoute.url) {
        throw new Error(`Could not find a route associated to tab name: ${tabName}`);
    }

    return generatePath(correspondingRoute.url, urlParams);
};

/**
 * Navigates to the route corresponding to the given tab name
 * @param urlParams - available from React props
 * @param tabName
 */
const navigateToTab = (tabName, urlParams, locationState) => {
    let correspondingRouteUrl = generateTabUrl(tabName, urlParams);

    history.push(correspondingRouteUrl, locationState);
};

const isUrlMatch = (url, tabName) => {
    let correspondingRoute = routesByKey[tabName];
    if (correspondingRoute && correspondingRoute.url) {
        return matchPath(url, {
            path: correspondingRoute.url,
            exact: correspondingRoute.isExact || correspondingRoute.isMainPath
        });
    }
    return false;
};

const isUrlRelatedToTab = (url, tabName) => {
    let relatedTabNames = routesByKey[tabName].relatedRoutes || [];

    return relatedTabNames.find((relatedTabName) => {
        let relatedRoute = routesByKey[relatedTabName];
        return relatedRoute ? isUrlMatch(url, relatedRoute.tabNameKey) : false;
    });
};

const isUrlMatchOrRelatedToTab = (url, tabName) => {
    return isUrlMatch(url, tabName) || isUrlRelatedToTab(url, tabName);
};

const isUrlRelatedToParentTab = (url, parentTabName) => {
    const routesWithParentTabName = routesArray.filter((route) => route.parentTabName === parentTabName);
    return routesWithParentTabName.some((route) => isUrlMatchOrRelatedToTab(url, route.tabName));
};

export {
    history,
    generateTabUrl,
    navigateToTab,
    isUrlMatch,
    isUrlRelatedToTab,
    isUrlMatchOrRelatedToTab,
    isUrlRelatedToParentTab
};
